import { render, staticRenderFns } from "./PageTranslationContent.vue?vue&type=template&id=75e01a04&"
import script from "./PageTranslationContent.vue?vue&type=script&lang=ts&"
export * from "./PageTranslationContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports